const footer = () => {
  return (
    <div className="footer">
      <div>
        <footer
          className="text-center text-lg-start text-white mt-5"
          style={{ backgroundColor: "#3e4551", width: "100%" }}
        >
          <div className="container p-4 pb-0">
            <section>
              <div className="row">
                <div className="col-lg-4 col-md-6 mb-4 mb-md-0">
                  <h5 className="text-uppercase" style={{ color: "#FFC718" }}>
                    M - Usman
                  </h5>

                  <p>
                    A product description is a form of marketing copy used to
                    describe and explain the benefits of your product. In other
                    words, it provides all the information and details of your
                    product on your ecommerce site. These product details can be
                    one sentence, a short paragraph or bulleted. They can be
                    serious, funny or quirky.
                  </p>
                </div>

                <div className="col-lg-2 col-md-6 mb-4 mb-md-0">
                  <h5 className="text-uppercase" style={{ color: "#FFC718" }}>
                    Links
                  </h5>

                  <ul className="list-unstyled mb-0">
                    <li>
                      <a href="#!" className="text-white">
                        Home
                      </a>
                    </li>
                    <li>
                      <a href="#!" className="text-white">
                        About
                      </a>
                    </li>
                    <li>
                      <a href="#!" className="text-white">
                        Cart
                      </a>
                    </li>
                    <li>
                      <a href="#!" className="text-white">
                        Add Cart
                      </a>
                    </li>
                  </ul>
                </div>

                <div className="col-lg-2 col-md-6 mb-4 mb-md-0">
                  <h5 className="text-uppercase" style={{ color: "#FFC718" }}>
                    Contact
                  </h5>

                  <ul className="list-unstyled mb-0">
                    <li>
                      <a href="#!" className="text-white">
                        M USMAN
                      </a>
                    </li>
                    <li>
                      <a href="#!" className="text-white">
                        usmanryk65@gmail.com
                      </a>
                    </li>
                    <li>
                      <a href="#!" className="text-white">
                        +92 30001271444
                      </a>
                    </li>
                    <li>
                      <a href="#!" className="text-white">
                        usmancodehack@github.com
                      </a>
                    </li>
                  </ul>
                </div>

                <div className="col-lg-2 col-md-6 mb-4 mb-md-0">
                  <h5 className="text-uppercase" style={{ color: "#FFC718" }}>
                    Project
                  </h5>

                  <ul className="list-unstyled mb-0">
                    <li>
                      <a href="#!" className="text-white">
                        HTML
                      </a>
                    </li>
                    <li>
                      <a href="#!" className="text-white">
                        CSS
                      </a>
                    </li>
                    <li>
                      <a href="#!" className="text-white">
                        JavaScript
                      </a>
                    </li>
                    <li>
                      <a href="#!" className="text-white">
                        React JS , Next JS
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </section>

            <hr className="mb-4" />

            <section className="">
              <p className="d-flex justify-content-center align-items-center">
                <span className="me-3" style={{ color: "#FFC718" }}>
                  Register for free
                </span>
                <button
                  type="button"
                  className="btn btn-outline-light btn-rounded"
                >
                  Sign up!
                </button>
              </p>
            </section>

            <hr className="mb-4" />
          </div>

          <div
            className="text-center p-3"
            style={{ backgroundColor: "rgba(0, 0, 0, 0.2)" }}
          >
            @ 2024:
            <a className="text-white" href="https://mdbootstrap.com/">
              M USMAN
            </a>
          </div>
        </footer>
      </div>
    </div>
  );
};
export default footer;
